import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

console.log("Base URL in API:", baseURL);

const API = axios.create({
  baseURL,
  withCredentials: true, 
});


API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default API;
